import { render, staticRenderFns } from "./TransactionsDetails.vue?vue&type=template&id=cdaafb3a&"
import script from "./TransactionsDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdaafb3a')) {
      api.createRecord('cdaafb3a', component.options)
    } else {
      api.reload('cdaafb3a', component.options)
    }
    module.hot.accept("./TransactionsDetails.vue?vue&type=template&id=cdaafb3a&", function () {
      api.rerender('cdaafb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransactionsDetails.vue"
export default component.exports